import React from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import { useTranslation } from "react-i18next";
import { Button, Grid, Typography, Box } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";

const Product = (props) => {
  const { t } = useTranslation();
  const { item, addToCart, carts, incrementQuantity, decrementQuantity } = props;
  const cartItem = carts.find((cartItem) => cartItem.id === item.id);

  return (
    <div className="row">
      <div className="col col-lg-5 col-12">
        <div className="shop-single-slider">
          <div className="slider-nav">
            <Zoom>
              <img src={item.proImg} alt={item.title} />
            </Zoom>
          </div>
        </div>
      </div>
      <div className="col col-lg-7 col-12">
        <div className="product-details">
          <h2>{item.title}</h2>
          <span>{item.price}{" "} {t('currency')}</span>
          <p>{item.description}</p>
          <Grid display="flex" alignItems="center" mt={2} sx={{ gap: 2 }}>
             <div className="add-to-cart">
            <button
              data-bs-toggle="tooltip"
              data-bs-html="true"
              title={t(`addToCart`)}
              onClick={() => addToCart(item, 1, null, null, t)}>
              {t(`addToCart`)}
            </button>
          </div>
            <Box display="flex" alignItems="center" mt={2} sx={{ gap: 2, width: 150, justifyContent: "center" }}>
              <Button
                variant="outlined"
                onClick={() => {
                  if (!cartItem) {
                    addToCart(item, 1, null, null, t); // If not in cart, add to cart
                  } else {
                    incrementQuantity(cartItem.id);
                  }
                }}
                sx={{ minWidth: 40, height: 40, borderColor: "#db9e30", color: "#db9e30", backgroundColor: "#f7f7f7", '&:hover': { borderColor: "#db9e30", backgroundColor: "#f5f5f5" } }}
              >
                <AddIcon sx={{ color: "#db9e30" }} />
              </Button>

              <Typography variant="h6">{cartItem?.qty || 1}</Typography>

              <Button
                variant="outlined"
                onClick={() => decrementQuantity(cartItem?.id)}
                sx={{ minWidth: 40, height: 40, borderColor: "#db9e30", color: "#db9e30",backgroundColor: "#f7f7f7", '&:hover': { borderColor: "#db9e30", backgroundColor: "#f5f5f5" } }}
              > 
                <RemoveIcon sx={{ color: "#db9e30" }} />
              </Button>
            </Box>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default Product;
